import { rei } from "@/services/api"

class ImpressaoService {
  static certidaoNascimento (impressao) {
    const options = {
      responseType: 'arraybuffer'
    }

    return rei.post(`impressao/certidao/nascimento`, { impressao }, options)
      .then(response => {
        let blob = new Blob([response.data], { type: 'application/pdf' })
        let url = window.URL.createObjectURL(blob)

        return url
      })
  }

  static termoNascimento (impressao) {
    const options = {
      responseType: 'arraybuffer'
    }

    return rei.post(`impressao/termo/nascimento`, impressao, options)
      .then(response => {
        let blob = new Blob([response.data], { type: 'application/pdf' })
        let url = window.URL.createObjectURL(blob)

        return url
      })
  }

  static certidaoObito (impressao) {
    const options = {
      responseType: 'arraybuffer'
    }

    return rei.post(`impressao/certidao/obito`, { impressao }, options)
      .then(response => {
        let blob = new Blob([response.data], { type: 'application/pdf' })
        let url = window.URL.createObjectURL(blob)

        return url
      })
  }

  static termoObito (impressao) {
    const options = {
      responseType: 'arraybuffer'
    }

    return rei.post(`impressao/termo/obito`, impressao, options)
      .then(response => {
        let blob = new Blob([response.data], { type: 'application/pdf' })
        let url = window.URL.createObjectURL(blob)

        return url
      })
  }

  static getTemplate (tipo, params) {
    return rei.post(`impressao/templates/${tipo}/${params.template}/${params.id}`, params.post)
      .then(res => res.data)
  }

  static certidaoCasamento (impressao) {
    const options = {
      responseType: 'arraybuffer'
    }

    return rei.post(`impressao/certidao/casamento`, { impressao }, options)
      .then(response => {
        let blob = new Blob([response.data], { type: 'application/pdf' })
        let url = window.URL.createObjectURL(blob)

        return url
      })
  }

  static termoCasamento (impressao) {
    const options = {
      responseType: 'arraybuffer'
    }

    return rei.post(`impressao/termo/casamento`, impressao, options)
      .then(response => {
        let blob = new Blob([response.data], { type: 'application/pdf' })
        let url = window.URL.createObjectURL(blob)

        return url
      })
  }

  static termoHabilitacao (impressao) {
    const options = {
      responseType: 'arraybuffer'
    }

    return rei.post(`impressao/termo/habilitacao`, impressao, options)
      .then(response => {
        let blob = new Blob([response.data], { type: 'application/pdf' })
        let url = window.URL.createObjectURL(blob)

        return url
      })
  }

  static etiqueta (impressao) {
    const options = {
      responseType: 'arraybuffer'
    }

    return rei.post(`impressao/etiqueta-pdf`, impressao, options)
      .then(response => {
        let blob = new Blob([response.data], { type: 'application/pdf' })
        let url = window.URL.createObjectURL(blob)

        return url
      })
  }

  static inteiroTeor (impressao) {
    const options = {
      responseType: 'arraybuffer'
    }

    return rei.post(`impressao/certidao/inteiro-teor`, { impressao }, options)
      .then(response => {
        let blob = new Blob([response.data], { type: 'application/pdf' })
        let url = window.URL.createObjectURL(blob)

        return url
      })
  }
}

export default ImpressaoService
